import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../AppIcon';

const Footer = () => {
  const currentYear = new Date()?.getFullYear();

  const footerSections = [
    {
      title: 'Product',
      links: [
        { label: 'Platform Demo', path: '/platform-demo' },
        { label: 'Enterprise Solutions', path: '/enterprise-solutions' },
        { label: 'API Documentation', path: '/api-documentation' },
        { label: 'Pricing', path: '/pricing' }
      ]
    },
    {
      title: 'Company',
      links: [
        { label: 'About Us', path: '/about' },
        { label: 'Careers', path: '/careers' },
        { label: 'Press', path: '/press' },
        { label: 'Contact', path: '/contact' }
      ]
    },
    {
      title: 'Resources',
      links: [
        { label: 'Blog', path: '/blog' },
        { label: 'Case Studies', path: '/case-studies' },
        { label: 'Policy Guides', path: '/guides' },
        { label: 'Policy Calendar', path: '/calendar' }
      ]
    },
    {
      title: 'Legal',
      links: [
        { label: 'Privacy Policy', path: '/privacy' },
        { label: 'Terms of Service', path: '/terms' },
        { label: 'Security', path: '/security' },
        { label: 'Data Protection', path: '/data-protection' }
      ]
    }
  ];

  const socialLinks = [
    { name: 'LinkedIn', icon: 'Linkedin', url: 'https://linkedin.com' },
    { name: 'Twitter', icon: 'Twitter', url: 'https://twitter.com' },
    { name: 'Facebook', icon: 'Facebook', url: 'https://facebook.com' },
    { name: 'Youtube', icon: 'Youtube', url: 'https://youtube.com' }
  ];

  return (
    <footer className="bg-gradient-to-br from-[#1B1B20] via-[#1B1B20] to-[#0A0A0A] text-white border-t border-white/10 mt-auto">
      <div className="max-w-7xl mx-auto px-6 py-12">
        {/* Logo Section */}
        <div className="mb-8 pb-8 border-b border-white/10">
          <Link to="/homepage" className="inline-block">
            <img 
              src="/assets/images/PA-Large-Final-white-policy-1769835760009.png" 
              alt="PolicyAlerts - Medical Policy Monitoring Platform" 
              className="h-10 w-auto"
            />
          </Link>
          <p className="text-gray-400 mt-4 max-w-md">
            Medical Policy, Monitored. Real-time tracking of policy changes across all major payers.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {footerSections?.map((section) => (
            <div key={section?.title}>
              <h3 className="text-sm font-semibold text-white mb-4">{section?.title}</h3>
              <div className="flex flex-col gap-2">
                {section?.links?.map((link) => (
                  <Link
                    key={link?.path}
                    to={link?.path}
                    className="text-sm text-gray-400 hover:text-white transition-colors"
                  >
                    {link?.label}
                  </Link>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-400">
            © {currentYear} PolicyAlerts. Medical Policy, Monitored. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            {socialLinks?.map((social) => (
              <a
                key={social?.name}
                href={social?.url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors"
                aria-label={social?.name}
              >
                <Icon name={social?.icon} size={20} />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;